import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import './ActiveList.css';
import { ServicegetCommunication, ServiceResendSMS } from "../Services/Service";
import 'jquery/dist/jquery.min.js';
import Table from './DataTable/DataTable';
import { CustomLoader, ModalBox } from "../Services/CommonLibrary";
import { downloadExcelFromHTML } from './Utils';

const queryParams = new URLSearchParams(window.location.search);
const status = queryParams.get('status');

function CommunicationText() {

    const clickhandler = name => console.log("delete", name);

    const [selectedStatus, setSelectedStatus] = useState("");
    const [loading, setLoading] = useState(true);
    const [loadingExport, setLoadingExport] = useState(false);
    const [showExportButton, setShowExportButton] = useState(true);

    const [currentPage, setCurrentPage] = useState(1);
    const startIndex = (currentPage - 1) * 50;

    const [serviceData, setServiceData] = useState([]);

    var storage = JSON.parse(localStorage.getItem('programDetail'))
        ? JSON.parse(localStorage.getItem('programDetail'))
        : 0;

    let programId = storage.programId;
    const nav = useNavigate();
    const accessFrom = localStorage.getItem('access');
    let limit = '';

    const dropStatus = [
        { value: 'onboarded', label: 'Onboarded' },
        { value: 'reminder1', label: 'Reminder 1' },
        { value: 'reminder2', label: 'Reminder 2' },
        { value: 'reminder3', label: 'Reminder 3' },
    ];

    const [showModal, setShowModal] = useState(false);
    const handleClose = () => setShowModal(false);
    const [encId, setEncId] = useState('');

    useEffect(() => {
        fetchSmsData('onboarded', '');
    }, []);

    /* ---------------- FETCH SMS DATA (LIKE WHATSAPP) ---------------- */
    const fetchSmsData = async (programStatus, smsStatus) => {
        setLoading(true);
        try {
            const res = await ServicegetCommunication(programStatus, smsStatus);
            setServiceData(res?.data?.data?.communicationlist || []);
        } catch (err) {
            console.error("SMS fetch error:", err);
            setServiceData([]);
        }
        setLoading(false);
    };

    /* ---------------- PROGRAM STATUS CHANGE ---------------- */
    const onValueChange = (e) => {
        if (e.target.id === 'filterStatus') {
            fetchSmsData(e.target.value, selectedStatus);
        }
    };

    /* ---------------- STATUS CHANGE ---------------- */
    const onStatusChange = (e) => {
        const value = e.target.value;
        setSelectedStatus(value);
        const programStatus = document.getElementById('filterStatus')?.value || 'onboarded';
        fetchSmsData(programStatus, value);
    };

    /* ---------------- EXPORT DATA ---------------- */
    const fetchExportData = async () => {
        setLoadingExport(true);
        try {
            const programStatus = document.getElementById('filterStatus')?.value || 'onboarded';
            const res = await ServicegetCommunication(programStatus, selectedStatus, "excel");
            const excelData = res?.data || [];
            downloadExcelFromHTML(excelData, "SMS_Communication_Data");
        } catch (err) {
            console.error("Export error:", err);
        }
        setLoadingExport(false);
    };

    const viewPopup = (enc_id) => {
        setEncId('');
        setEncId(enc_id);
        setShowModal(true);
    };

    const resendSms = async () => {
        setLoading(true);
        ServiceResendSMS(encId)
            .then((res) => {
                setEncId('');
                setLoading(false);
                handleClose();
            });
    };

    /* ---------------- TABLE COLUMNS ---------------- */
    const columns = [
        {
            name: "#",
            cell: (row, index) => startIndex + index + 1,
            sortable: false,
            grow: 0,
            center: true
        },
        {
            name: "Mobile",
            selector: row => row.mobile,
            sortable: true,
            grow: 1,
            center: true
        },
        {
            name: "SMS Text",
            cell: (row) => <div className="text-wrap">{row.smsText}</div>,
            sortable: true,
            grow: 4,
            style: { whiteSpace: 'unset' },
            center: true
        },
        {
            name: "Status",
            selector: row => row.status,
            sortable: true,
            grow: 1,
            conditionalCellStyles: [
                {
                    when: row => row.status === 'delivered',
                    style: { color: 'green', textTransform: 'capitalize' },
                },
                {
                    when: row => row.status === 'Delivered',
                    style: { color: 'green', textTransform: 'capitalize' },
                },
                {
                    when: row => row.status === 'Undelivered' || row.status === 'undelivered',
                    style: { color: 'red', textTransform: 'capitalize' },
                },
                {
                    when: row => row.status === 'Failed',
                    style: { color: 'red', textTransform: 'capitalize' },
                },
            ],
            center: true
        },
        {
            name: "Sent Date",
            selector: row => row.createdTime,
            sortable: true,
            grow: 2,
            center: true
        },
        {
            name: "Action", //Consultation Notes
            button: true,
            omit: (accessFrom === 'superadmin' || accessFrom === 'admin') ? false : true,
            center: true,
            cell: row =>
                <button
                    className='btn btn-primary btn-sm btn-edit'
                    onClick={() => viewPopup(row.enc_id)}
                >
                    Resend
                </button>
        }
    ];

    const modalBodyComponent = (
        <>
            <span>
                Are You sure?
                <br /><br />
                <button className='btn btn-primary me-2' onClick={resendSms}>Yes</button>
                <button className='btn btn-secondary' onClick={handleClose}>No</button>
            </span>
        </>
    );

    const onChangePage = (page) => {
        setCurrentPage(page);
    };

    return (
        <section className=''>

            <div className="row mt-3">
                <div className="col-md-3">
                    <select
                        className="form-control form-control-sm"
                        name="filterStatus"
                        id="filterStatus"
                        onChange={onValueChange}
                    >
                        {dropStatus.map((item, i) => (
                            <option value={item.value} key={i}>
                                {item.label}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="col-md-2">
                    <select
                        className="form-control form-control-sm"
                        value={selectedStatus}
                        onChange={onStatusChange}
                    >
                        <option value="">All Status</option>
                        <option value="Delivered">Delivered</option>
                        <option value="Undelivered">Undelivered</option>
                    </select>
                </div>

                {showExportButton && (
                    <div className="col-md-3 ms-auto text-end">
                        <button
                            className="btn btn-success me-2 btn-sm"
                            onClick={fetchExportData}
                            disabled={loadingExport}
                        >
                            {loadingExport ? 'Exporting Data...' : 'Export Data'}
                        </button>
                    </div>
                )}
            </div>

            <div className='row'>
                <div className='table-responsive'>
                    <Table
                        data={serviceData}
                        column={columns}
                        click={clickhandler}
                        onChangePage={onChangePage}
                    />
                </div>
            </div>

            {loading ? <CustomLoader /> : null}

            {showModal ?
                <ModalBox
                    handleClose={handleClose}
                    showModaln={showModal}
                    titlen="Alert"
                    bodyn={modalBodyComponent}
                />
                : ''
            }

            {/* 
            <section className='projects-section'>
                <div className='row'>
                    <div className="FL">
                        <div className='table-responsive'>
                            <Table data={serviceData} column={columns} title={'Communication'} click={clickhandler} />
                        </div>
                    </div>
                </div>
                { loading ? <CustomLoader /> : null }
            </section> 
            */}
        </section>
    );
}

export default CommunicationText;
